import { LeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { global_var } from "../../services/cs-lab-config";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const BackBtn = () => {
    const navigate = useNavigate();
    const [changeNavigate, setChangeNavigate] = useState();

    useEffect(() => {
      if(changeNavigate){
        navigate(changeNavigate);
      }
    }, [changeNavigate, navigate]);

    const handleBack = () => {
        if(global_var.pathStack?.length > 0){
            setChangeNavigate(global_var.pathStack[global_var.pathStack.length - 1]);
          } else {
            navigate(-1);
        }
    }

    return (
        <Link onClick={handleBack}  className="mr-2">
            <span className="mt-2  back-button">
                <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
            </span>
        </Link>
    );
};
export default BackBtn;
